<template lang="pug">
  .custom-input__autocomplete(
    v-show="suggetionList.length > 0"
  )
    ul.dropdown-menu
      li.dropdown-menu__item(
        v-for="suggetion in suggetionList"
        @click="onBeforeClickSuggetion(suggetion)"
      )
        .dropdown-menu__link {{ suggetion.value }}
</template>
<script>
export default {
  name: "CustomAutocomplete",
  props: {
    showAutocomplete: {
      type: Boolean,
      default: false
    },
    suggetionList: {
      type: Array,
      default: () => []
    },
    onClickSuggetion: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({}),
  methods: {
    onBeforeClickSuggetion(suggetion) {
      this.onClickSuggetion(suggetion);
    },
    bodyClick() {
      this.$emit("close");
    }
  },
  mounted() {
    document.body.addEventListener("click", this.bodyClick);
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.bodyClick);
  }
};
</script>
